/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class ReferenceMerchantField extends PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field>
        <label>Reference Merchant ID (Optional)</label>
        <Input
          type="number"
          min="0"
          onChange={e => onChange('reference_merchant_id', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/fields/referenceMerchantField.js